






import * as converter from 'color-convert'

export default {
  props: {
    color: {
      type: String,
      default: 'red',
    },
    width: {
      type: String,
      default: 'red',
    },
  },
  computed: {
    styles() {
      return {
        color: this.color,
        backgroundColor: this.getRgbaColor(this.color, 0.1),
        borderColor: this.color,
        width: this.width + 'px',
      }
    },
  },
  methods: {
    getRgbaColor(color, alpha) {
      return `rgba(${converter.hex.rgb(color).join(',')}, ${alpha})`
    },
  },
}
